/**
 * Blocks the single-order mark-as-completed footer when any auth-on-file
 * J-code's CPT-table values (start/end date, auth #, total visits) differ from
 * the auth-letter values shown on the Authorization Details screen.
 *
 * @module useAuthLetterFieldMatchMarkCompleteBlocker
 */
import { useMemo } from "react";
import { useDataAccumulatorForSingleOrder } from "../../../context/dataAccumulatorForSingleOrder";
import { shouldDisableMarkCompleteForAuthLetterFieldMismatch } from "../utils/authLetterFieldMatchMarkCompleteGuard";

/**
 * Recomputes whenever Postgres-backed auth-on-file data changes.
 *
 * @return boolean: True if mark-as-completed should be disabled for a field mismatch
 */
export const useAuthLetterFieldMatchMarkCompleteBlocker = (): boolean => {
  const { authOnFileDetails } = useDataAccumulatorForSingleOrder();
  return useMemo(
    () =>
      shouldDisableMarkCompleteForAuthLetterFieldMismatch(
        authOnFileDetails?.auth_on_file,
      ),
    [authOnFileDetails?.auth_on_file],
  );
};
